export const getMomentLocale = localeId => {
  return {
    months : Array.from({length: 12}, (x, index) => (new Date(0, index, 2).toLocaleDateString(localeId, {month: 'long'}))),
    monthsShort : Array.from({length: 12}, (x, index) => (new Date(0, index, 2).toLocaleDateString(localeId, {month: 'short'}))),
    weekdaysMin : Array.from({length: 7}, (x, index) => (new Date(0, 0, index, 2).toLocaleDateString(localeId, {weekday: 'short'}))),
  }
}



// WEBPACK FOOTER //
// ./src/services/service-moment-locale.js